import React, { createContext, useState, useContext, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    menus: 'Menus',
    categories: 'Categories',
    dishes: 'Dishes',
    addItem: 'Add Item',
    editItem: 'Edit Item',
    reports: 'Reports',
    settings: 'Settings',
    admin: 'Admin',
    adminUser: 'Admin User',
    administrator: 'Administrator',
    
    // Dashboard
    totalMenus: 'Total Menus',
    totalCategories: 'Total Categories',
    totalDishes: 'Total Dishes',
    quickActions: 'Quick Actions',
    addNewDish: 'Add New Dish',
    viewReports: 'View Reports',
    systemOverview: 'System Overview',
    welcomeMessage: 'Welcome to Restaurant Management System. Here you can manage your restaurant\'s menus, categories, and dishes. Use sidebar to navigate between different sections and perform CRUD operations on your restaurant data.',
    restaurantSections: 'Restaurant sections',
    foodCategories: 'Food categories',
    availableDishes: 'Available dishes',
    
    // Categories
    selectMenu: 'Select Menu',
    chooseMenu: 'Choose a menu',
    pleaseSelectMenuFirst: 'Please select a menu from the dropdown above to view its dishes',
    noCategoriesInMenu: 'This menu has no categories. Please add categories first.',
    categoriesFor: 'Categories for',
    addCategory: 'Add Category',
    addMenu: 'Add Menu',
    categoryName: 'Category Name',
    menuName: 'Menu Name',
    enterCategoryName: 'Enter category name',
    noCategoriesFound: 'No categories found',
    noCategoriesAvailable: 'No categories available',
    addFirstCategory: 'Add your first category to this menu',
    categoryAdded: 'Category added successfully',
    failedToAddCategory: 'Failed to add category',
    failedToFetchCategories: 'Failed to fetch categories',
    categoryDeleted: 'Category deleted successfully',
    failedToDeleteCategory: 'Failed to delete category',
    viewDishes: 'View Dishes',
    
    // Dishes
    selectCategory: 'Select Category',
    dishesFor: 'Dishes for',
    dishName: 'Dish Name',
    dishDescription: 'Dish Description',
    dishPrice: 'Dish Price',
    dishPriceLBP: 'Price in Lebanese Lira (LBP)',
    dishPriceUSD: 'Price in USD (Auto-calculated)',
    dishImage: 'Dish Image',
    enterDishName: 'Enter dish name',
    enterDishDescription: 'Enter dish description',
    enterDishPrice: 'Enter dish price',
    noDishesFound: 'No dishes found',
    noDishesInCategory: 'No dishes in this category',
    addFirstDish: 'Add your first dish to this category',
    dishAdded: 'Dish added successfully',
    dishUpdated: 'Dish updated successfully',
    dishDeleted: 'Dish deleted successfully',
    failedToSaveDish: 'Failed to save dish',
    failedToUpdateDish: 'Failed to update dish',
    failedToDeleteDish: 'Failed to delete dish',
    failedToFetchDishes: 'Failed to fetch dishes',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    image: 'Image',
    name: 'Name',
    category: 'Category',
    price: 'Price',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    dishesCount: 'Dishes',
    imagesCount: 'Images',
    
    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    search: 'Search',
    refresh: 'Refresh',
    logout: 'Logout',
    login: 'Login',
    username: 'Username',
    password: 'Password',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    name: 'Name',
    description: 'Description',
    price: 'Price',
    image: 'Image',
    category: 'Category',
    menu: 'Menu',
    dish: 'Dish',
    create: 'Create',
    update: 'Update',
    view: 'View',
    back: 'Back',
    confirmDelete: 'Are you sure you want to delete',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    clear: 'Clear',
    select: 'Select',
    choose: 'Choose',
    upload: 'Upload',
    download: 'Download',
    add: 'Add',
    dragDropImage: 'Drag and drop image here or click to browse',
    selectMenuFirst: 'Please select a menu first',
    browseFiles: 'Browse Files',
    
    // Settings
    settings: 'Settings',
    generalSettings: 'General Settings',
    businessInfo: 'Business Information',
    openingHours: 'Opening Hours',
    notificationPreferences: 'Notification Preferences',
    appearance: 'Appearance',
    restaurantName: 'Restaurant Name',
    currency: 'Currency',
    taxRate: 'Tax Rate (%)',
    dollarExchangeRate: 'Dollar Exchange Rate',
    primaryColor: 'Primary Color',
    theme: 'Theme',
    light: 'Light',
    saveSettings: 'Save Settings',
    resetToDefault: 'Reset to Default',
    saving: 'Saving...',
    settingsSavedSuccessfully: 'Settings saved successfully!',
    errorSavingSettings: 'Error saving settings. Please try again.',
    settingsResetToDefault: 'Settings reset to default!',
    confirmResetSettings: 'Are you sure you want to reset all settings to default?',
    choosePreferredTheme: 'Choose your preferred theme appearance',
    clickToChangePrimaryColor: 'Click to change primary color',
    currentExchangeRate: 'Current exchange rate for USD to local currency',
  },
  ar: {
    // Navigation
    dashboard: 'لوحة التحكم',
    menus: 'القوائم',
    categories: 'الفئات',
    dishes: 'الأطباق',
    addItem: 'إضافة عنصر',
    editItem: 'تعديل عنصر',
    reports: 'التقارير',
    settings: 'الإعدادات',
    admin: 'المسؤول',
    adminUser: 'المستخدم المسؤول',
    administrator: 'مدير النظام',
    
    // Dashboard
    totalMenus: 'إجمالي القوائم',
    totalCategories: 'إجمالي الفئات',
    totalDishes: 'إجمالي الأطباق',
    quickActions: 'إجراءات سريعة',
    addNewDish: 'إضافة طبق جديد',
    viewReports: 'عرض التقارير',
    systemOverview: 'نظرة عامة على النظام',
    welcomeMessage: 'مرحبًا بك في نظام إدارة المطاعم. هنا يمكنك إدارة قوائم مطعمك وفئاته وأطباقه. استخدم الشريط الجانبي للتنقل بين الأقسام المختلفة وتنفيذ عمليات CRUD على بيانات مطعمك.',
    restaurantSections: 'أقسام المطعم',
    foodCategories: 'فئات الطعام',
    availableDishes: 'الأطباق المتاحة',
    
    // Categories
    selectMenu: 'اختر القائمة',
    chooseMenu: 'اختر قائمة',
    pleaseSelectMenuFirst: 'الرجاء اختيار قائمة من القائمة المنسدلة أعلاه لعرض أطباقها',
    noCategoriesInMenu: 'هذه القائمة ليس بها فئات. الرجاء إضافة فئات أولاً.',
    categoriesFor: 'فئات لـ',
    addCategory: 'إضافة فئة',
    addMenu: 'إضافة قائمة',
    categoryName: 'اسم الفئة',
    menuName: 'اسم القائمة',
    enterCategoryName: 'أدخل اسم الفئة',
    noCategoriesFound: 'لم يتم العثور على فئات',
    noCategoriesAvailable: 'لا توجد فئات متاحة',
    addFirstCategory: 'أضف أول فئة لهذه القائمة',
    categoryAdded: 'تمت إضافة الفئة بنجاح',
    failedToAddCategory: 'فشلت إضافة الفئة',
    failedToFetchCategories: 'فشل جلب الفئات',
    viewDishes: 'عرض الأطباق',
    
    // Dishes
    selectCategory: 'اختر الفئة',
    dishesFor: 'أطباق لـ',
    dishName: 'اسم الطبق',
    dishDescription: 'وصف الطبق',
    dishPrice: 'سعر الطبق',
    dishPriceLBP: 'السعر بالليرة اللبنانية',
    dishPriceUSD: 'السعر بالدولار (محسوب تلقائياً)',
    dishImage: 'صورة الطبق',
    enterDishName: 'أدخل اسم الطبق',
    enterDishDescription: 'أدخل وصف الطبق',
    enterDishPrice: 'أدخل سعر الطبق',
    noDishesFound: 'لم يتم العثور على أطباق',
    noDishesInCategory: 'لا توجد أطباق في هذه الفئة',
    addFirstDish: 'أضف أول طبق لهذه الفئة',
    dishAdded: 'تمت إضافة الطبق بنجاح',
    dishUpdated: 'تم تحديث الطبق بنجاح',
    dishDeleted: 'تم حذف الطبق بنجاح',
    failedToSaveDish: 'فشل حفظ الطبق',
    failedToUpdateDish: 'فشل تحديث الطبق',
    failedToDeleteDish: 'فشل حذف الطبق',
    failedToFetchDishes: 'فشل جلب الأطباق',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    image: 'الصورة',
    name: 'الاسم',
    category: 'الفئة',
    price: 'السعر',
    status: 'الحالة',
    actions: 'الإجراءات',
    active: 'نشط',
    dishesCount: 'الأطباق',
    imagesCount: 'الصور',
    
    // Common
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجح',
    yes: 'نعم',
    no: 'لا',
    close: 'إغلاق',
    search: 'بحث',
    refresh: 'تحديث',
    logout: 'تسجيل الخروج',
    login: 'تسجيل الدخول',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    name: 'الاسم',
    description: 'الوصف',
    price: 'السعر',
    image: 'الصورة',
    category: 'الفئة',
    menu: 'القائمة',
    dish: 'الطبق',
    create: 'إنشاء',
    update: 'تحديث',
    view: 'عرض',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    clear: 'مسح',
    select: 'اختر',
    choose: 'اختر',
    upload: 'رفع',
    download: 'تنزيل',
    add: 'إضافة',
    dragDropImage: 'اسحب وأفلت الصورة هنا أو انقر للاستعراض',
    selectMenuFirst: 'الرجاء اختيار قائمة أولاً',
    browseFiles: 'استعراض الملفات',
    
    // Settings
    settings: 'الإعدادات',
    generalSettings: 'الإعدادات العامة',
    businessInfo: 'معلومات العمل',
    openingHours: 'ساعات العمل',
    notificationPreferences: 'تفضيلات الإشعارات',
    appearance: 'المظهر',
    restaurantName: 'اسم المطعم',
    currency: 'العملة',
    taxRate: 'معدل الضريبة (%)',
    dollarExchangeRate: 'سعر صرف الدولار',
    primaryColor: 'اللون الأساسي',
    theme: 'السمة',
    light: 'فاتح',
    saveSettings: 'حفظ الإعدادات',
    resetToDefault: 'إعادة تعيين إلى الافتراضي',
    saving: 'جاري الحفظ...',
    settingsSavedSuccessfully: 'تم حفظ الإعدادات بنجاح!',
    errorSavingSettings: 'خطأ في حفظ الإعدادات. يرجى المحاولة مرة أخرى.',
    settingsResetToDefault: 'تم إعادة تعيين الإعدادات إلى الافتراضي!',
    confirmResetSettings: 'هل أنت متأكد من أنك تريد إعادة تعيين جميع الإعدادات إلى الافتراضي؟',
    choosePreferredTheme: 'اختر المظهر المفضل لك',
    clickToChangePrimaryColor: 'انقر لتغيير اللون الأساسي',
    currentExchangeRate: 'سعر الصرف الحالي للدولار إلى العملة المحلية',
  }
};

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  useEffect(() => {
    document.body.setAttribute('data-language', language);
    document.documentElement.setAttribute('lang', language === 'ar' ? 'ar' : 'en');
  }, [language]);

  const t = (key) => {
    return translations[language][key] || translations['en'][key] || key;
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
};
